import React from 'react';
import ProductModel from '../../../models/productModel';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContextMenu, DropdownItem } from '@weezevent/nacre';
import NavTitle from './NavTitle';

export default function ProductContextMenu({ organization, product }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [search, setSearch] = React.useState(null);

    const [products] = ProductModel.useApiModel(
        {
            organizationId: organization.id,
            query: {
                search
            }
        },
        [organization, search]
    );

    const handleSwitch = React.useCallback(
        product => {
            history.push(`/ticket/O${organization.id}/products/${product.id}`);
        },
        [history, organization, product]
    );

    const productList = React.useMemo(() => {
        let list = [];
        products?.forEach(product => {
            list.push(
                <DropdownItem key={product.id} onClick={() => handleSwitch(product)}>
                    {product.name}
                </DropdownItem>
            );
        });
        return list;
    }, [products, handleSwitch]);

    const handleSearch = React.useCallback(query => {
        setSearch(query || null);
    }, []);

    const defaultTooltipProps = {
        margin: false,
        triggerOnHover: true,
        position: 'top-start'
    };

    return (
        <ContextMenu
            catchphrase={<NavTitle title={t('ticket.common.cross-selling')} link={`/ticket/O${organization.id}/products`} />}
            title={product.name}
            titleTooltipProps={{ ...defaultTooltipProps, title: product.name, position: 'bottom-start', offset: [0, -5] }}
            switchMenuProps={{
                footerText: t('ticket.switchProduct.footer_cta'),
                onFooterClick: () => history.push(`/ticket/O${organization.id}/products`),
                searchProps: {
                    onChange: (synth, val) => {
                        handleSearch(val);
                    },
                    placeholder: t('ticket.switchProduct.search_placeholder')
                },
                text: t('ticket.switchProduct.cta'),
                items: productList
            }}
        />
    );
}
